import React from 'react';
import { Checkbox } from 'material-ui';
import R from 'ramda';


const ManageExtrasOfferSelectProducts = props => {
  const {
    data,
    offersOrExtras,
    onTextFieldChangeWithKeyPath,
  } = props;

  const getPrimaryName = obj => offersOrExtras.type === 'extras'
    ? (obj.extraType || 'this extra')
    : (obj.offerName || 'this offer');
  const selectedIndex = offersOrExtras.list.findIndex(o => o._id === offersOrExtras.selectedId);
  const getSecondaryName = obj => {
    const name = offersOrExtras.type === 'extras'
      ? obj.extraCode
      : obj.bookingCode;
    return name
      ? `(${name})`
      : '';
  };

  const getProdDisplayName = product => {
    const ratePName = R.filter(o => o.productName === product.productName, offersOrExtras.productsArray).length > 1
      && product.ratePackageName;
    return `${product.productName}${ratePName ? ` - ` : ''}${ratePName || ''}`;
  };

  const currentObject = offersOrExtras.createNew ? data : offersOrExtras.list.find(obj => obj._id === offersOrExtras.selectedId) || {};
  const currentObjectName = `${
    getPrimaryName(currentObject)
  } ${getSecondaryName(currentObject)}`;
  return (
    <div
      style={{
        padding: '16px',
        width: '300px',
        borderLeft: '1px solid #e0e0e0',
      }}
    >
      <p>
        Please select which room type(s)/product(s) that <b>{currentObjectName}</b> should apply to:
      </p>
      {
        (offersOrExtras.toDelete) && (
          <p style={{ color: '#00bcd4' }}>
            We've unselected the {getProdDisplayName(offersOrExtras.productsArray.find(x => x._id === offersOrExtras.toDelete))}. Click SAVE to remove this {
            offersOrExtras.type === 'extras' ? 'Extra' : 'Special Offer'
          }.
          </p>
        )
      }
      {
        !currentObject.ratePackages.length && (
          <p style={{ color: '#ff4081' }}>
            Warning: <b>{currentObjectName}</b> will {offersOrExtras.createNew ? 'not be added' : 'be removed'}.
          </p>
        )
      }
      <Checkbox
        style={{ marginBottom: '16px' }}
        checked={currentObject.ratePackages.length === offersOrExtras.productsArray.length}
        label="Select All"
        labelStyle={{ fontSize: '12px' }}
        onCheck={() => onTextFieldChangeWithKeyPath({
          keyPath: offersOrExtras.createNew ? ['data', 'ratePackages'] : ['offersOrExtras', 'list', selectedIndex, 'ratePackages'],
          value: currentObject.ratePackages.length === offersOrExtras.productsArray.length
            ? []
            : offersOrExtras.productsArray.map(
              product => product._id,
            ),
        })}
      />
      {
        (offersOrExtras.productsArray || []).map(product => {
          const ratePackageId = product._id;
          const checked = R.contains(ratePackageId, currentObject.ratePackages || []);
          return (
            <Checkbox
              key={ratePackageId}
              checked={checked}
              label={getProdDisplayName(product)}
              labelStyle={{ fontSize: '12px' }}
              onCheck={() => onTextFieldChangeWithKeyPath({
                keyPath: offersOrExtras.createNew ? ['data', 'ratePackages'] : ['offersOrExtras', 'list', selectedIndex, 'ratePackages'],
                value: checked
                  ? currentObject.ratePackages.filter(str => str !== ratePackageId)
                  : R.append(ratePackageId, currentObject.ratePackages),
              })}
            />
          );
        })
      }
    </div>
  );
};

export default ManageExtrasOfferSelectProducts;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/manage-extras-offers/select-products.jsx